import iterateEntityWithDisplay from './iterate-entity-with-display'
import _ from 'lodash'

export default {
  getSideEffects (displayId, menuBlob) {
    let sideEffects = []

    iterateEntityWithDisplay(displayId, _.get(menuBlob, 'departments'), entity => {
      sideEffects.push(`The Display will be removed from the <strong>KPS Settings</strong> in the <strong>Department ${entity.info.name}</strong>.`)
    })

    return sideEffects
  },
  applySideEffects (displayId, menuBlob) {
    iterateEntityWithDisplay(displayId, _.get(menuBlob, 'departments'), entity => {
      const list = entity.kps.displays
      list.splice(list.indexOf(displayId), 1)
    })
  }
}
